<template>
  <FormErrorMessages
    v-if="isWriteAvailable"
    title="Registration form error messages"
    :formData="formData"
    formType="listing_registration"
  />
</template>

<script>
  import FormErrorMessages from '@/components/shared/FormErrorMessages'
  import mixins from '@/utils/mixins'

  export default {
    name: 'SettingsError',
    mixins: [mixins.isWriteAvailable],
    components: {FormErrorMessages},
    data() {
      return {
        formData: {
          invalidToken: '',
          noToken: ''
        },
        // DON'T DELETE! need for isWriteAvailable mixin
        scopeForWrite: 'registration:write'
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/pages/Listing/ListingSettings/errors.vue